"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const core_1 = require("@material-ui/core");
const web_core_form_utils_1 = require("@opus/web.core.form.utils");
const web_core_form_label_field_1 = require("@opus/web.core.form.label-field");
const TextField = (_a) => {
    var { name, validate, mode, displayValueFormat } = _a, rest = __rest(_a, ["name", "validate", "mode", "displayValueFormat"]);
    const [field] = formik_1.useField({ name, validate: mode === web_core_form_utils_1.FormMode.Edit && validate });
    const error = web_core_form_utils_1.useFieldError(name);
    if (mode === web_core_form_utils_1.FormMode.View) {
        return react_1.default.createElement(web_core_form_label_field_1.LabelField, Object.assign({ name: name, displayValueFormat: displayValueFormat }, rest));
    }
    return react_1.default.createElement(core_1.TextField, Object.assign({ id: name, helperText: error, error: !!error, fullWidth: true }, field, rest));
};
exports.TextField = TextField;
exports.TextField.defaultProps = {
    mode: web_core_form_utils_1.FormMode.Edit,
};
//# sourceMappingURL=text-field.js.map